var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "container content_call_to_action_container" },
          [
            _c("div", { staticClass: "row align-items-center" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "h3",
                  { staticClass: "content_call_to_action_container_h3" },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.heading) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "content_call_to_action_container_p" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.message) +
                      "\n                        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn--call-to-action",
                    attrs: { href: _vm.linkUrl },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.linkText) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }